export default __webpack_public_path__ + "static/media/scan-image.eab501ac.svg";